<div class="drug-cards">
  <div *ngFor="let drugCard of drugCards">
    <div class="drug-card-container">
      <div class="check-icon">
        <img
          class="check-image"
          src="/assets/img/static-pages/medigi/v2-images/standalone-icons/check-grad.svg"
          alt="Check Mark"
        />
      </div>
      <div class="drug-card">
        <div class="drug-card-top">
          <img class="drug-image" src="{{ drugCard.image }}" alt="" />
        </div>
        <p class="drug-title">{{ drugCard.copy }}</p>
      </div>
    </div>
  </div>
</div>
